import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const [selected, setSelected] = useState<'premium' | 'basic'>('premium');
  const checkoutUrl = selected === 'basic' ? 'https://checkout.ars.descargatop.com/cart/46942758600962:1' : 'https://checkout.ars.descargatop.com/cart/47452901703938:1';
  return <section id="pricing" className="py-20 px-4 bg-[#111111] scroll-mt-10" data-id="element-101">
      <div className="max-w-3xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-103">
          <div className="text-center mb-12" data-id="element-104">
            <h2 className="text-4xl md:text-6xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-105">
              🛒 ELEGÍ TU PLAN
            </h2>
            <p className="text-lg text-gray-400 font-medium" data-id="element-106">
              Descarga inmediata. Acceso de por vida.
            </p>
          </div>

          <div className="space-y-4 mb-10" data-id="element-107">
            {/* Basic Plan Row */}
            <button onClick={() => setSelected('basic')} className={`w-full rounded-2xl p-5 md:p-6 flex items-center gap-4 md:gap-6 transition-all duration-300 cursor-pointer text-left ${selected === 'basic' ? 'bg-[#1a1a1a] border-2 border-gray-500' : 'bg-[#1a1a1a] border-2 border-[#2a2a2a] opacity-70 hover:opacity-90'}`} data-id="element-108">
              {/* Radio */}
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'basic' ? 'border-white' : 'border-gray-600'}`} data-id="element-109">
                {selected === 'basic' && <div className="w-3 h-3 rounded-full bg-white" data-id="element-110" />}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0" data-id="element-111">
                <div className="flex items-center gap-2 mb-1" data-id="element-112">
                  <span className="text-xl" data-id="element-113">📘</span>
                  <h3 className="text-lg md:text-xl font-black text-white uppercase tracking-wide" data-id="element-114">
                    PACK BÁSICO
                  </h3>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-medium" data-id="element-115">
                  4 libros + 400 citas + bonos
                </p>
                <div className="flex flex-col gap-1 mt-2" data-id="element-116">
                  <p className="text-xs text-gray-400" data-id="element-117">
                    📘 100 Citas Mamá e Hija
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-118">
                    📗 100 Citas Mamá e Hijo
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-119">
                    📙 100 Citas Papá e Hija
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-120">
                    📕 100 Citas Papá e Hijo
                  </p>
                </div>
              </div>

              {/* Price */}
              <div className="text-right flex-shrink-0" data-id="element-121">
                <p className="text-sm text-gray-500 line-through font-medium" data-id="element-122">
                  $39.990
                </p>
                <p className="text-3xl md:text-4xl font-black text-white" data-id="element-123">
                  $19.990
                </p>
              </div>
            </button>

            {/* Premium Plan Row */}
            <button onClick={() => setSelected('premium')} className={`w-full rounded-2xl p-5 md:p-6 flex items-center gap-4 md:gap-6 transition-all duration-300 cursor-pointer text-left relative ${selected === 'premium' ? 'bg-[#1a1a00] border-2 border-yellow-400 shadow-[0_0_30px_rgba(250,204,21,0.15)]' : 'bg-[#1a1a1a] border-2 border-[#2a2a2a] opacity-70 hover:opacity-90'}`} data-id="element-124">
              {/* Radio */}
              <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selected === 'premium' ? 'border-yellow-400' : 'border-gray-600'}`} data-id="element-125">
                {selected === 'premium' && <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-126" />}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0" data-id="element-127">
                <div className="flex items-center gap-2 mb-2" data-id="element-128">
                  <span className="text-xl" data-id="element-129">🏆</span>
                  <h3 className="text-lg md:text-xl font-black text-white uppercase tracking-wide" data-id="element-130">
                    PACK COMPLETO
                  </h3>
                </div>
                <div className="flex flex-wrap items-center gap-2 mb-2" data-id="element-131">
                  <span className="inline-flex items-center gap-1 bg-gradient-to-r from-yellow-600 to-yellow-500 text-black text-xs font-black px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-132">
                    ⭐ Más elegido
                  </span>
                  <span className="inline-flex items-center text-yellow-400 text-xs font-bold px-3 py-1 rounded-full border border-yellow-400/50 uppercase tracking-wider" data-id="element-133">
                    Ahorrás $10.000
                  </span>
                </div>
                <p className="text-sm md:text-base text-gray-400 font-medium" data-id="element-134">
                  6 libros + 600 citas + bonos
                </p>
                <div className="flex flex-col gap-1 mt-2" data-id="element-135">
                  <p className="text-sm text-yellow-300 font-bold" data-id="element-136">
                    + 💑 100 Citas en Pareja
                  </p>
                  <p className="text-sm text-yellow-300 font-bold" data-id="element-137">
                    + 👨‍👩‍👧 100 Citas en Familia
                  </p>
                </div>
              </div>

              {/* Price */}
              <div className="text-right flex-shrink-0" data-id="element-138">
                <p className="text-sm text-gray-500 line-through font-medium" data-id="element-139">
                  $59.990
                </p>
                <p className="text-3xl md:text-4xl font-black text-yellow-400" data-id="element-140">
                  $29.990
                </p>
              </div>
            </button>
          </div>

          {/* Checkout CTA — links to actual checkout based on selection */}
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-141">
            <motion.div whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            scale: [1, 1.02, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative w-full group" data-id="element-142">
              <div className="absolute -inset-1 bg-gradient-to-r from-red-600 to-orange-500 rounded-xl blur opacity-70 group-hover:opacity-100 transition duration-200" data-id="element-143"></div>
              <div className="relative w-full flex flex-col items-center justify-center px-6 py-4 bg-gradient-to-b from-red-500 to-red-700 border-b-4 border-red-900 rounded-xl shadow-2xl text-white font-black text-xl md:text-2xl uppercase tracking-wide hover:from-red-400 hover:to-red-600 transition-all" data-id="element-144">
                <div className="flex items-center gap-2 text-center" data-id="element-145">
                  👉 COMPRAR AHORA
                </div>
                <span className="text-sm md:text-base font-medium text-red-100 mt-1 normal-case tracking-normal" data-id="element-146">
                  Descarga inmediata • Garantía de 7 días
                </span>
              </div>
            </motion.div>
          </a>

          <div className="flex items-center justify-center gap-4 mt-6 text-gray-500 text-sm" data-id="element-147">
            <span className="flex items-center gap-1" data-id="element-148">🔒 Pago seguro</span>
            <span data-id="element-149">•</span>
            <span className="flex items-center gap-1" data-id="element-150">
              📥 Descarga inmediata
            </span>
            <span data-id="element-151">•</span>
            <span className="flex items-center gap-1" data-id="element-152">✅ Garantía 7 días</span>
          </div>
        </motion.div>
      </div>
    </section>;
}